import {ChangeDetectionStrategy, Component, HostBinding, Input} from '@angular/core';

@Component({
    selector: 'total-item',
    templateUrl: './total-item.component.html',
    styleUrls: ['./total-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TotalItemComponent {
    @HostBinding('class.slim')
    @Input()
    title: string;
    @Input() value: string;
    @Input() percent: string;
    @Input() negative: boolean;
    @Input() complex: boolean;
    @Input() subTitles: string[];
    @Input() tooltipText: string;
    @Input() relatedDate: string;

    readonly arrowUpName = 'arrow-up';
    readonly arrowDownName = 'arrow-down';

    arrowName(negative: boolean): string {
        return negative ? this.arrowDownName : this.arrowUpName;
    }

    isArray(array: any): boolean {
        return Array.isArray(array);
    }
}
